import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "ticketino-api-client";

import Header from "./components/Header";

import confirmationImg from "../images/confirmation-img.png";

const Step_Confirmation = () => {
    const { orderId } = useParams();

    const [token] = useState(sessionStorage.getItem("token"));
    const [order, setOrder] = useState([]);
    const [organizerId, setOrganizerId] = useState(0);

    const [error, setError] = useState(null);

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    // setting the base url of the npm package api calls
    api.defaults.baseURL = baseUrl;

    // fetching resources
    const [resources, setResources] = useState({});

    // fetching resources
    let { language } = useParams();

    let languageId = 0;

    // changing languageId according to the url
    switch (language) {
        case ("de" || "DE"):
            languageId = 1;
            break;
        case ("fr" || "FR"):
            languageId = 2;
            break;
        case ("en" || "EN"):
            languageId = 3;
            break;
        default:
            languageId = 0;
            language = "de";
            break;
    }

    useEffect(() => {
        // gtm - purchase
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'purchase'
        });
    }, [])

    useEffect(() => {
        loadToken();
    }, []); //only on first page load

    useEffect(() => {
        requestResources();
    }, [language]); //everytime language is changed

    const loadToken = async () => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;
        api.defaults.headers.common['Authorization'] = "Bearer " + token;

        sessionStorage.removeItem("orderId");

        requestFormSettings()
    };

    const requestFormSettings = async () => {
        await axios.get(`form/formsettings`).then((res) => {
            setOrganizerId(res.data.organizerId);
            loadOrder(orderId);
        });
    };

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const loadOrder = async (orderId, attempt = 1) => {
        try {
            const fetchedOrder = await getOrderByOrderId(orderId);

            // If invoiceNumber missing and attempts < 3, retry
            if ((!fetchedOrder?.invoiceNumber || fetchedOrder.invoiceNumber === "") && attempt < 7) {
                console.log(`Retrying to fetch order... Attempt ${attempt + 1}`);
                await new Promise((resolve) => setTimeout(resolve, 2000)); // optional delay before retry
                return loadOrder(orderId, attempt + 1);
            }

            if (!fetchedOrder?.invoiceNumber) {
                setError("Invoice number is missing after multiple attempts.");
            } else {
                setError(null);
            }

            setOrder(fetchedOrder);
        } catch (error) {
            console.error(error);
            setError("Failed to load order.");
        }
    };

    const getOrderByOrderId = async (orderId) => {
        try {
            const res = await axios.get(`${baseUrl}/Order/${orderId}`);
            return res.data;
        }
        catch (error) {
            console.error(error);
        }
    }

    const onSubmit = () => {
        window.location.href = "https://www.finanz-ch.ch/";
    };

    return (
        <div className="page-container">
            <Header language={language} />
            <div className="container wrapper-small">
                <div className="row mt-2">
                    <div className="col-md-12">
                        <span className="text-title d-block">{resources?.EventName}</span>
                        <span className="text-subtitle d-block">{resources?.ConfirmationTitle}</span>
                    </div>
                </div>


                {/* Show error message if any */}
                {error && (
                    <div className="row mt-2">
                        <div className="col-md-12">
                            <div className="alert alert-danger" role="alert">
                                <p dangerouslySetInnerHTML={{ __html: resources?.ErrorOrder?.replaceAll("${orderId}", orderId) }}></p>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {/* fullwidth background container */}
            {!error && order && order.invoiceNumber && order.invoiceNumber !== 0 && (
                <>
                    <div className="mt-4 fullwidth-bg-container">
                        <div className="container wrapper-small">
                            <div className="row d-flex align-items-center" style={{ minHeight: '300px' }}>
                                <div className="col-md-5 p-5 d-flex justify-content-center">
                                    <img className="img-fluid confirmation-img" src={confirmationImg} alt="confirmation" />
                                </div>
                                <div className="col-md-7 d-flex flex-column justify-content-center align-items-center" style={{ height: '100%' }}>
                                    <div>
                                        <span className="text-subtitle font-color-darkblue" dangerouslySetInnerHTML={{ __html: resources?.ConfirmationSubtitle }} />
                                    </div>
                                    <div className="mt-4 ms-4">
                                        <span dangerouslySetInnerHTML={{ __html: resources?.ConfirmationDescription }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="container wrapper-small">
                        <div className="row mt-5">
                            <div className="col-md-12 font-14px">
                                <i><span dangerouslySetInnerHTML={{ __html: resources?.ConfirmationFooter }} /></i>
                            </div>
                        </div>

                        <div className="row mt-4">
                            <div className="col-md-12 text-end">
                                <button className="btn button-custom" onClick={() => onSubmit()}>{resources?._BackToHomePage}</button>
                            </div>
                        </div>

                        <p className="mt-4">
                            <small style={{ color: 'grey', fontSize: '10px' }}>powered by <a style={{ color: 'grey', textDecoration: 'none' }} href="https://organizer.ticketino.com/de" target="_blank">TICKETINO</a></small>
                        </p>
                    </div>
                </>
            )}
        </div>
    )
}

export default Step_Confirmation